import request from '@/utils/request';
export function login(data) {
  return request({
    url: '/admin/Login/login',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/admin/AdminUser/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout(token, userid) {
  return request({
    url: '/admin/Login/logout',
    method: 'get',
    params: {// token,
      // id: userid
    }
  });
}
/**
 * 验证码
 *  @param {array} params 请求参数
 */

export function verify(params) {
  return request({
    url: '/admin/Login/verify',
    method: 'get',
    params: params
  });
}
/**
 * 用户分配权限
 * @param {array} data 请求数据
 */

export function rule(data) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';

  if (method === 'post') {
    return request({
      url: '/admin/AdminUser/rule',
      method: 'post',
      data: data
    });
  } else {
    return request({
      url: '/admin/AdminUser/rule',
      method: 'get',
      params: data
    });
  }
}
export function newrule(data) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return request({
    url: 'admin/AdminRole/list',
    method: 'get',
    params: data
  });
}
export function get_show_logo(data) {
  var method = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'get';
  return request({
    url: 'admin/AdminSysconfig/getConfig',
    method: 'get',
    params: data
  });
}